/* import __COLOCATED_TEMPLATE__ from './body.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */
import Component from '@glimmer/component';
import { objectTypes } from 'embercom/models/data/matching-system/matching-constants';

export default class ContentEditorPanelsGoalBodyComponent extends Component {
  rulesetType = objectTypes.ruleset;
}
